import type { ReactNode } from 'react';
import { Botao } from './Botao';
import { Aviso, Dialogo } from './blocos';
import css from './DialogoConfirmar.module.css';

/**
 * Confirmação de ação que não dá para desfazer (no lugar do window.confirm do navegador).
 * "Cancelar" vem primeiro: ao abrir, o navegador põe o foco nele (1º focável do <dialog>), então
 * um Enter sem querer não apaga nada. Fica aberto com "carregando"
 * até a ação terminar e mostra o erro aqui mesmo, se houver.
 */
export function DialogoConfirmar({
  aberto,
  aoFechar,
  titulo,
  children,
  textoConfirmar,
  aoConfirmar,
  carregando,
  erro,
  perigo = true,
}: {
  aberto: boolean;
  aoFechar: () => void;
  titulo: string;
  children: ReactNode;
  textoConfirmar: string;
  aoConfirmar: () => void;
  carregando?: boolean;
  erro?: string | null | undefined;
  /** Ação destrutiva (botão vermelho). */
  perigo?: boolean;
}) {
  return (
    <Dialogo aberto={aberto} aoFechar={aoFechar} rotulo={titulo}>
      <div className={css.corpo}>
        <h2 className={css.titulo}>{titulo}</h2>
        <div className={css.texto}>{children}</div>
      </div>
      {erro && <Aviso>{erro}</Aviso>}
      <div className={css.acoes}>
        <Botao variante="secundario" onClick={aoFechar} disabled={carregando}>
          Cancelar
        </Botao>
        <Botao
          variante="primario"
          className={perigo ? css.confirmarPerigo : undefined}
          onClick={aoConfirmar}
          carregando={carregando}
        >
          {textoConfirmar}
        </Botao>
      </div>
    </Dialogo>
  );
}
